<template>
    <Row>
        <i-col span="12" style="padding-right:10px">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <FormItem label="集团名称">
            <span>
                {{this.companyname}}
            </span>
        </FormItem> 
         <FormItem label="支付方式代码" prop="code">
          <Select v-model="formValidate.code" style="width:200px">
              <i-option v-for="item in codelist" :value="item.id" :key="item.id">{{ item.name }}</i-option>
          </Select>        </FormItem>
        <FormItem label="额外参数" prop="data" v-if="formValidate.code!='wechat'">
            <!-- <textarea class="paydata"></textarea> -->
            <i-input v-model="formValidate.data" type="textarea" :autosize="true" placeholder=""></i-input>
            <!-- <i-input v-model="formValidate.data" placeholder="请输入额外参数"></i-input> -->
        </FormItem>
          <FormItem label="支付模式" v-if="formValidate.code=='wechat'">
          <Select v-model="formValidate.pay_mode" style="width:200px">
              <i-option v-for="item in pay_modelist" :value="item.id" :key="item.id">{{ item.name }}</i-option>
          </Select>      
          </FormItem>
      <template v-if="formValidate.pay_mode!='service_mode_3'">
          <FormItem label="商户号" prop="mch_id"  v-if="formValidate.code=='wechat'">
            <i-input v-model="formValidate.mch_id" type="text" :autosize="true" placeholder="请输入商户号"></i-input>
        </FormItem>
        <FormItem label="公众号APPID" prop="appid"  v-if="formValidate.code=='wechat'">
            <i-input v-model="formValidate.appid" type="text" :autosize="true" placeholder="请输入公众号APPID"></i-input>
        </FormItem>
        <FormItem label="支付密钥" prop="key"  v-if="formValidate.pay_mode=='service_mode_2'">
            <i-input v-model="formValidate.key" type="text" :autosize="true" placeholder="支付密钥"></i-input>
        </FormItem>
                    </template>
         <!-- <FormItem label="服务商appid" prop="service_mch_appid"  v-if="formValidate.code=='wechat'">
            <i-input v-model="formValidate.service_mch_appid" type="text" :autosize="true" placeholder="请输入服务商appid"></i-input>
        </FormItem>
         <FormItem label="服务商商户号" prop="service_mch_id"  v-if="formValidate.code=='wechat'">
            <i-input v-model="formValidate.service_mch_id" type="text" :autosize="true" placeholder="请输入服务商商户号"></i-input>
        </FormItem> -->
          <template v-if="formValidate.pay_mode=='service_mode_3'">
        <FormItem label="公众号APPID " prop="parent_appid" >
            <i-input v-model="formValidate.parent_appid" type="text" :autosize="true" placeholder="请输入公众号APPID"></i-input>
        </FormItem>
        <FormItem label="商户号" prop="parent_mch_id">
            <i-input v-model="formValidate.parent_mch_id" type="text" :autosize="true" placeholder="请输入商户号"></i-input>
        </FormItem>
        <FormItem label="子公众号APPID" prop="appid">
            <i-input v-model="formValidate.appid" type="text" :autosize="true" placeholder="请输入子公众号APPID"></i-input>
        </FormItem>
        <FormItem label="支付密钥" prop="key">
            <i-input v-model="formValidate.key" type="text" :autosize="true" placeholder="请输入商户号"></i-input>
        </FormItem>

        </template>
 
        <FormItem>
            <Button type="primary" @click="handleSubmit1('formValidate')">提交</Button>
        </FormItem>
    </Form>  
        </i-col>
        <i-col span="12">
        </i-col>
    </Row>
</template>
<script>
import { companylist } from "../../api/companyapi";
import { company_update } from "../../api/paymethodapi";
import { mapState } from "vuex";
import format from "../../constant/Json.js";
export default {
  data() {
    const validatecompany_id = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择集团"));
      } else {
        callback();
      }
    };
    return {
      company_id: "",
      loading1: false,
      options1: [],
      list: [],
      companyname: "",
      pay_modelist: [
        {
          name: "服务商模式1",
          id: "service_mode_1"
        },
        {
          name: "服务商模式2",
          id: "service_mode_2"
        },
        {
          name: "服务商模式3",
          id: "service_mode_3"
        }
      ],
      formValidate: {
        code: "",
        data: "",
        appid: "",
        mch_id: "",
        parent_mch_id: "",
        parent_appid: "",
        // service_mch_appid: "",
        // service_mch_id: "",
        pay_mode: "",
        key: ""
      },
      ruleValidate: {
        code: [
          { required: true, message: "请输入支付方式代码", trigger: "blur" }
        ],
        mch_id: [{ required: true, message: "请输入商户号", trigger: "blur" }],
        appid: [{ required: true, message: "请输入", trigger: "blur" }],
        parent_mch_id: [{ required: true, message: "请输入", trigger: "blur" }],
        parent_appid: [{ required: true, message: "请输入", trigger: "blur" }],
        company_id: [{ validator: validatecompany_id, trigger: "change" }]
      }
    };
  },
  computed: {
    ...mapState({
      codelist: state => state.paycode
    })
  },
  methods: {
    sreplace(str) {
      var whitespace =
        " \n\r\t\f\x0b\xa0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000";
      for (var i = 0, len = str.length; i < len; i++) {
        if (whitespace.indexOf(str.charAt(i)) === -1) {
          str = str.substring(i);
          break;
        }
      }
      for (i = str.length - 1; i >= 0; i--) {
        if (whitespace.indexOf(str.charAt(i)) === -1) {
          str = str.substring(0, i + 1);
          break;
        }
      }
      return whitespace.indexOf(str.charAt(0)) === -1 ? str : "";
    },
    handleSubmit1(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.company_update();
        } else {
          this.$Message.error("请检查输入");
        }
      });
    },
    company_update() {
      let par = {
        company_id: this.company_id,
        paymethod_code: this.formValidate.code,
        data: ""
      };
      if (par.paymethod_code == "wechat") {
        par.data = {
          appid: this.formValidate.appid,
          mch_id: this.formValidate.mch_id,
          pay_mode: this.formValidate.pay_mode
          // service_mch_id: this.formValidate.service_mch_id,
          // service_mch_appid: this.formValidate.service_mch_appid
        };
        if (par.data.pay_mode == "service_mode_2") {
          par.data.key = this.formValidate.key;
        }
        if (par.data.pay_mode == "service_mode_3") {
          par.data.key = this.formValidate.key;
          par.data.parent_appid = this.formValidate.parent_appid;
          par.data.parent_mch_id = this.formValidate.parent_mch_id;
          delete par.data.mch_id;
        }
        par.data = JSON.stringify(par.data);
      } else {
        par.data = this.formValidate.data.replace(/[\r\n]/g, "");
        par.data = this.sreplace(par.data);
        par.data = par.data.toString();
      }
      this.$Loading.start();
      company_update(par).then(res => {
        this.$Loading.finish();
        let data = res.data;
        if (data.code == 1) {
          this.$Message.success("修改成功");
          this.$router.push({ path: "paymethodcompany" });
        } else {
          this.$Message.error(data.message);
        }
      });
    },
    init() {
      this.formValidate = {
        code: "",
        data: ""
      };
      this.company_id = "";
      this.options1 = [];
    }
  },
  mounted() {
    if (this.$route && this.$route.query) {
      this.formValidate.code = this.$route.query.code;
      debugger;
      if (this.formValidate.code == "wechat") {
        var data = JSON.parse(this.$route.query.data);
        if (data && data.appid ) {
          this.formValidate.appid = data.appid;
          this.formValidate.pay_mode = data.pay_mode;
          this.formValidate.key = data.key;
        }
        if(data&&data.mch_id){
                    this.formValidate.mch_id = data.mch_id;

        }
        if (data && data.parent_appid && data.parent_mch_id) {
          this.formValidate.parent_appid = data.parent_appid;
          this.formValidate.parent_mch_id = data.parent_mch_id;
        }
      } else {
        this.formValidate.data = format(this.$route.query.data);
      }
      this.companyname = this.$route.query.name;
      this.company_id = this.$route.query.id;
    }

    //   this.company_id=this.$route.query.id
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/System/companyupdte.vue